import React from 'react';
import { needsStudentLink } from './enquiryStudentUtils';

export default function V1StudentBadge({ enquiry, onClick }) {
  if (!needsStudentLink(enquiry)) return null;

  return (
    <span
      className="v1-badge"
      title="Legacy enquiry — link a student"
      onClick={(e) => {
        e.stopPropagation();
        onClick?.();
      }}
    >
      V1
    </span>
  );
}
